import * as firebase from 'firebase/app'

firebase.initializeApp({
  apiKey: "AIzaSyCfuINyGcrPmITd_4ppzkRhsH1P0QyEkOQ",
  authDomain: "cvc-it-support.firebaseapp.com",
  databaseURL: "https://cvc-it-support.firebaseio.com",
  projectId: "cvc-it-support",
  storageBucket: "cvc-it-support.appspot.com",
  messagingSenderId: "606027429977",
  appId: "1:606027429977:web:770e3c8b0d17e75c"
})

export default firebase;